import React from 'react';
import { useTranslation } from 'react-i18next';
import Editor from 'shared/components/Editor/Editor';
import { IconDispatcher } from 'shared/Icons';
import { Button } from 'shared/ui-basics';
import { Flex } from '../modals/comment-center.style';

type Props = {
    value?: string;
    onSubmit: (value: string, mentions:any) => void;
    placeholder?: string;
    autoFocus?: boolean;
}

const CommentEditor = (props: Props) => {
    const { t } = useTranslation();
    const [mentions, setMentions] = React.useState<any>([]);
    const [value, setValue] = React.useState<string>(props.value || '');

    const onSubmit = () => {
        props.onSubmit(value,mentions);
        setValue('');
    }
    const onClickEnter = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' && !e.shiftKey && value !== '') {
            e.preventDefault();
            onSubmit();
        }
    }
    return (
        <Flex align='center' justify='space-between' className='w-100'>
            <div style={{ maxWidth: 'calc(100% - 40px)', width:'100%',height:'100%' }} onKeyDown={onClickEnter}>
                <Editor
                    value={value}
                    onChange={setValue as any}
                    disabled={false}
                    placeholder={t(props?.placeholder || 'TYPE_A_COMMENT')}
                    mentionFunction={setMentions}
                    hideToolbar={true}
                    autoFocus={props.autoFocus}
                />
            </div>
            <Button variant='dark' size ='s' onClick={onSubmit} disabled={value===""}>
                <IconDispatcher type='send' params={{ size: 'md' }} />
            </Button>
        </Flex>
    )
}


export default CommentEditor;